import FirstSection from "../sections/FirstSection/FirstSection";
import ThirdSection from "../sections/ThirdSection/ThirdSection";
import './Main.css'
import { observer } from "mobx-react-lite";
import State, { MAX_STEP } from "../store/State";
import { useEffect } from "react";
import { content } from "../types/enums";
import countries from "../sections/ThirdSection/countries";

function preloadImages(imageUrls) {
  imageUrls.forEach((url) => {
    const img = new Image();
    img.src = url;
  });
}

export const Main = observer(() => {

  useEffect(() => {
    const imageUrls = countries.flatMap((country) => [country.card, country.photo]).filter(Boolean);

    preloadImages(imageUrls);
  }, []);


  useEffect(() => {
    let startY: number;
    let endY: number;
    let touchOnModal = false;

    const isPopupOpen = () => State.getActiveCountryIndex() !== content.NO
    // Жесты по открытой панели модалки не крутят глобус; снаружи — можно
    const isInsideCountryModal = (target: EventTarget | null) =>
      State.getModalActive() &&
      target instanceof Element &&
      !!target.closest('[data-country-modal]')

    function handleSwipe(start: number, end: number) {
      if (State.getIsLoaded() === false) return
      if (isPopupOpen()) return
      if (touchOnModal) return
      if (State.isAnimation()) return
      const threshold = 50
      if (Math.abs(start - end) <= threshold) return

      if (State.isCountriesListOpen()) {
        State.closeCountriesList()
        return
      }
      if (start - end > threshold) State.plusStep()
      else State.minusStep()
    }

    const onWheel = (event: WheelEvent): void => {
      if (State.getIsLoaded() === false) return
      if (isPopupOpen()) return
      if (isInsideCountryModal(event.target)) return
      if (State.isAnimation()) return

      if (State.isCountriesListOpen()) {
        State.closeCountriesList()
        return
      }
      if (event.deltaY > 0) State.plusStep()
      else if (event.deltaY < 0) State.minusStep()
    }

    const onTouchStart = (e: TouchEvent) => {
      startY = e.touches[0].clientY;
      touchOnModal = isInsideCountryModal(e.target);
    }

    const onTouchEnd = (e: TouchEvent) => {
      endY = e.changedTouches[0].clientY;
      handleSwipe(startY, endY);
      touchOnModal = false;
    }

    // Вешаем оба типа жестов: isMobile может выставиться уже после mount
    document.addEventListener('touchstart', onTouchStart, { passive: true });
    document.addEventListener('touchend', onTouchEnd, { passive: true });
    window.addEventListener('wheel', onWheel, { passive: true });
    return () => {
      document.removeEventListener('touchstart', onTouchStart);
      document.removeEventListener('touchend', onTouchEnd);
      window.removeEventListener('wheel', onWheel);
    }
  }, [])

  const clickButton = (top: boolean) => {
    if (State.getStep() === 0 || State.getStep() >= MAX_STEP - 1) return
    if (State.getModalActive()) return
    if (State.isAnimation()) return
    if (!top) State.plusStep()
    else State.minusStep()
  }
  const bottomButton = () => {
    if (State.isAnimation()) return
    if (State.getStep() === 0) {
      State.plusStep()
      return
    }
    State.openCountriesList()
  }
  const planetSteps = State.getStep() > 0 && State.getStep() < MAX_STEP - 1 && !State.isCountriesListOpen()
  const buttonStyle = planetSteps && !State.getModalActive() ? 'show-button' : 'hide-button'
  const loadingActive = State.getIsLoaded()
  const loadingClass = loadingActive ? 'loading-loaded' : ''

  return (
    <div className={`main`} id='main' >
      <div id="loading-container" className={loadingClass}>
        <div className={loadingClass}>Пожалуйста, подождите, идет загрузка</div>
        <div id="loading-text" className={loadingClass}>
        </div>
      </div>
      <FirstSection />
      <ThirdSection />
      <div className={"button-left " + buttonStyle} onClick={() => clickButton(true)}>
        <div className="dialog-container-left">
          <p>Покрутить</p>
        </div>
      </div>

      <div className={"button-right " + buttonStyle} onClick={() => clickButton(false)}>
        <div className="dialog-container-right">
          <p>Покрутить</p>
        </div>
      </div>

      {loadingActive && <div className="button_bottom show-button" onClick={bottomButton}></div>}
    </div>
  )
});

export default Main
